import React from 'react';

const EntityLink = (props) => {
    const {href} = props.contentState.getEntity(props.entityKey).getData();
    return (
        <a href={href} style={{cursor: 'text'}} target="_blank" rel="noreferrer">
            {props.children}
        </a>
    );
};

export default EntityLink;
